import { Documento } from '@/types/presupuesto';
import WhatsAppEventModal from './WhatsAppEventModal';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tramite: any;
  documento: Documento;
};

const WhatsAppContabilidadDocumentoModal = ({
  open,
  onOpenChange,
  tramite,
  documento,
}: Props) => {
  return (
    <WhatsAppEventModal
      open={open}
      onOpenChange={onOpenChange}
      tramite={tramite}
      eventType="contabilidad.envio_documento"
      title="Enviar documento de contabilidad por WhatsApp"
      description="Se enviará el documento con enlace temporal seguro."
      contextOverrides={{ documento_id: documento.id }}
    />
  );
};

export default WhatsAppContabilidadDocumentoModal;
